export default "__VITE_ASSET__7055d0d5__"